import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

/**
 * 日本語用MatPaginatorIntl
 */
@Injectable({
  providedIn: 'root',
})
export class MatPaginatorIntlJp extends MatPaginatorIntl {
  /** 1ページあたりの件数のラベル */
  override itemsPerPageLabel = '1ページあたりの件数: ';
  /** 先頭ページボタンのラベル */
  override firstPageLabel = '最初のページへ';
  /** 前ページボタンのラベル */
  override previousPageLabel = '前のページへ';
  /** 次ページボタンのラベル */
  override nextPageLabel = '次のページへ';
  /** 末尾ページボタンのラベル */
  override lastPageLabel = '最後のページへ';

  /**
   * 範囲ラベルの取得
   * @param page ページ
   * @param pageSize ページサイズ
   * @param length 長さ
   * @returns ページ範囲文字列
   */
  override getRangeLabel = (
    page: number,
    pageSize: number,
    length: number
  ): string => {
    if (length <= 0) {
      return '';
    }

    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
    return `全 ${length} 件中 ${startIndex + 1} ～ ${endIndex} 件目`;
  };
}
